const LeadActionTypes = {
  SET_LEAD: 'SET_LEAD',
  RELOAD_LEAD: 'RELOAD_LEAD',
  RELOAD_CUSTOMER: 'RELOAD_CUSTOMER',
  RELOAD_OPPORTUNITY: 'RELOAD_OPPORTUNITY',
};

export default LeadActionTypes;
